import { forwardRef } from "react";

import * as RadixTooltip from "@radix-ui/react-tooltip";

import { cn } from "../index";

/** --------------------------------------------------------------------------------------------------------------------
 * TooltipProvider
 * ------------------------------------------------------------------------------------------------------------------ */

type ProviderProps = RadixTooltip.TooltipProviderProps;

const Provider = RadixTooltip.Provider;

Provider.displayName = "TooltipProvider";

/** --------------------------------------------------------------------------------------------------------------------
 * Tooltip
 * ------------------------------------------------------------------------------------------------------------------ */

type TooltipProps = RadixTooltip.TooltipProps;

const Root = RadixTooltip.Root;

Root.displayName = "Tooltip";

/** --------------------------------------------------------------------------------------------------------------------
 * TooltipTrigger
 * ------------------------------------------------------------------------------------------------------------------ */

type TriggerProps = RadixTooltip.TooltipTriggerProps;

const Trigger = RadixTooltip.Trigger;

Trigger.displayName = "TooltipTrigger";

/** --------------------------------------------------------------------------------------------------------------------
 * TooltipPortal
 * ------------------------------------------------------------------------------------------------------------------ */

type PortalProps = RadixTooltip.TooltipPortalProps;

const Portal = RadixTooltip.Portal;

Portal.displayName = "TooltipPortal";

/** --------------------------------------------------------------------------------------------------------------------
 * TooltipContent
 * ------------------------------------------------------------------------------------------------------------------ */

type ContentProps = RadixTooltip.TooltipContentProps;

const Content = forwardRef<HTMLDivElement, ContentProps>(({ className, children, ...props }, forwardedRed) => (
  <RadixTooltip.Content
    {...props}
    ref={forwardedRed}
    className={cn(
      "p-5 z-100000 rounded-[12px] bg-primary-dark-blue text-base whitespace-pre-line text-primary-white",
      className,
    )}
  >
    {children}
  </RadixTooltip.Content>
));

Content.displayName = "TooltipContent";

/** --------------------------------------------------------------------------------------------------------------------
 * TooltipArrow
 * ------------------------------------------------------------------------------------------------------------------ */

type ArrowProps = RadixTooltip.TooltipArrowProps;

const Arrow = forwardRef<SVGSVGElement, ArrowProps>(({ className, ...props }, forwardedRed) => (
  <RadixTooltip.Arrow {...props} ref={forwardedRed} className={cn("fill-primary-dark-blue", className)} />
));

Arrow.displayName = "TooltipArrow";

export { Arrow, Content, Portal, Provider, Root, Trigger };
export type { ArrowProps, ContentProps, PortalProps, ProviderProps, TooltipProps, TriggerProps };
